/**
 * Normalize an URL from arguments, ! and strip the rest !
 * @param    {String} path                        Pathname
 * @param    {Object.<string, string>} [params]   Key:Value with query parameters to attach
 * @param    {String} [hash=]                   hash to attach
 */
export const normalizeURL = (path, params, hash = '') => {
  const url = new URL(window.location);
  url.pathname = path;

  /**
   * We delete existing query params, they must be explicitly defined.
   * To keep any query params which are already in the current url,
   * you should pass them in params argument.
   * */
  url.searchParams.forEach((val, key) => {
    url.searchParams.delete(key);
  });
  url.search = '';

  if (params) {
    Object.entries(params).forEach((entry) => url.searchParams.set(...entry));
  }

  /**
   * We override existing hash ('' by default), it must be explicitly defined.
   * To keep the hash which is already in the current url,
   * you should pass it in hash argument.
   * */
  url.hash = hash;

  return url;
};
